import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider as OidcAuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import configJson from "./Config.json";
import "./index.css";
import { AuthProvider } from "./components/usecontext/AuthContext";
import reportWebVitals from "./reportWebVitals";

const root = createRoot(document.getElementById("root"));
const cognitoAuthConfig = {
  authority: configJson.authority,
  client_id: configJson.client_id,
  redirect_uri: configJson.redirect_uri,
  post_logout_redirect_uri: configJson.post_logout_redirect_uri,
  logout_uri: encodeURIComponent(configJson.logout_uri),
  response_type: configJson.response_type,
  scope: configJson.scope,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

root.render(
  <BrowserRouter>
    <OidcAuthProvider {...cognitoAuthConfig}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </OidcAuthProvider>
  </BrowserRouter>
);

reportWebVitals();
